<template lang="pug">

    div

        //- h3.ui.block.header {{ fieldSetModel.name }}

        dynamic-field(
            ref="fields"
            v-for='field in rootFieldModels'
            v-bind:key='field.id'
            v-bind:field="field"
            v-bind:field-models="fieldSetModel.fields"
            v-bind:value="value"
            v-on:input="updateModel($event)"
        )

</template>

<script>
    import * as R from 'ramda'
    import * as FormUtils from "@/utils/form"
    import DynamicField from "./form/DynamicField.vue"

    //noinspection JSUnusedGlobalSymbols
    export default {

        components: { DynamicField },

        computed: {

            rootFieldModels() {
                return R.compose(

                    // Sortieren nach Level
                    R.curry(FormUtils.sort_field_models_on_level)(2),

                    // Nach FieldModels auf Level 2 filter
                    R.curry(FormUtils.get_elements_by_level)(2),

                    // FieldModels auslesen
                    R.prop('fields')

                )(this.fieldSetModel)
            },

            $invalid() {
                return this.$refs.fields.find(field => field.$invalid) !== undefined
            }
        },

        methods: {

            $touch() {
                this.$refs.fields.forEach(field => field.$touch())
            },

            updateModel(value) {
                this.$emit('input', value)
            }

        },

        props: {
            fieldSetModel: {
                type: Object,
                required: true
            },
            value: {
                type: Object,
                required: true
            },
        }

    }

</script>
